// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cWJb","right":"styles_right__2z_it"};